<template>
  <el-container class="home-container">
    <!--      头部区域-->
    <el-header>
      <div> 温控中心</div>
    </el-header>
    <el-container class="home-container">
      <!--        侧边栏-->
      <el-aside
        :width="isCollapse ? '64px' : '200px'"
        style="background:#40407a;"
      >
        <div
          class="toggle-button"
          @click="toggleCollapse"
        >|||</div>
        <el-menu
          class="el-menu-vertical-demo"
          background-color="#40407a"
          text-color="#aaa69d"
          active-text-color="#fff"
          :default-active="activePath"
          :unique-opened="true"
          :collapse="isCollapse"
          :collapse-transition="false"
          router
        >
          <el-submenu index="1">
            <template slot="title">
              <i class="el-icon-location"></i>
              <span>服务器管理</span>
            </template>
            <el-menu-item
              index="mainmenu"
              @click="saveNavState(item.frame_id.toString())"
              v-for="item in frameList"
              :key="item.frame_id"
            ><i class="el-icon-menu"></i>
              <span>{{item.frame_name}}</span>
            </el-menu-item>
          </el-submenu>
          <!-- <el-menu-item
            index="mainmenu"
            @click="saveNavState('mainmenu')"
          > <i class="el-icon-video-camera-solid"></i><span>数据库中心</span></el-menu-item> -->
          <el-menu-item
            index="groups"
            @click="saveNavState('groups')"
          > <i class="el-icon-video-camera-solid"></i><span>机组管理</span></el-menu-item>
          <el-menu-item
            index="users"
            @click="saveNavState('users')"
          > <i class="el-icon-video-camera-solid"></i><span>用户管理</span></el-menu-item>
          <el-menu-item
            index="list"
            @click="saveNavState('list')"
          > <i class="el-icon-video-camera-solid"></i><span>联系我们</span></el-menu-item>
          <!-- <el-menu-item index="/" ><i class="el-icon-video-camera-solid"></i><sapn>返回主页</sapn></el-menu-item> -->
        </el-menu>
      </el-aside>
      <!--        主界面-->
      <el-main>
        <router-view :key="activePath"></router-view>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>

export default {

  data () {
    return {
      // 是否折叠
      isCollapse: false,
      activePath: 'default',
      username: '',
      loginTime: '',
      frameList: ''

    }
  },
  methods: {
    logout () {
      window.sessionStorage.clear()
      this.$router.push('/login')
    },
    // 展开侧边栏
    toggleCollapse () {
      this.isCollapse = !this.isCollapse
    },
    // 存储现激活地址
    saveNavState (activePath) {
      window.sessionStorage.setItem('activePath', activePath)
      this.activePath = activePath
    },
    async getFrameList () {
      const { data: res } = await this.$http.get('/frame/list')
      this.frameList = res.data
      console.log(res.data)
    }
  },
  created () {
    this.getFrameList()
    // console.log(this.roleList)
  }
}
</script>

<style lang="less" scoped>
.home-container {
  height: 100%;
}
header {
  display: flex;
  color: white;
  font-size: 20px;
  background: #2b5876; /* fallback for old browsers */
  background: -webkit-linear-gradient(
    to right,
    #4e4376,
    #2b5876
  ); /* Chrome 10-25, Safari 5.1-6 */
  background: linear-gradient(
    to right,
    #4e4376,
    #2b5876
  ); /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
  justify-content: center;
}
.el-header {
  > div {
    display: flex;
    align-items: center;

    span {
      margin-left: 15px;
    }
  }
}

.el-aside {
  background: #fff;
  transition: 1s;

  .el-menu {
    border-right: none;
  }
}

.el-main {
  background: #eaedf1;
}

.iconfont {
  margin-right: 10px;
}

.toggle-button {
  background: #4a5064;
  font-size: 10px;
  line-height: 24px;
  color: #fff;
  text-align: center;
  letter-spacing: 0.3em;
  cursor: pointer;
}
.menu-title {
  font-size: 18px;
}
.home-container {
  height: 100%;
}
el-aside {
  transition: 1s;
}
.el-submenu__title {
  transition: 1s;
}
</style>
